import { cn } from '@/lib/utils'

interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
}

export default function Card({ children, className, hover = false }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white rounded-2xl shadow-lg border border-gray-200 p-6',
        hover && 'hover:shadow-xl hover:scale-105 transition-all duration-300',
        className
      )}
    >
      {children}
    </div>
  )
}

